import { Table } from 'antd'

import { BitazzaText } from '../../../../components'
import { getColor } from '../../../../util/getColor'
import { Badges } from '../Badges'
import Styles from './UserRank.module.scss'
import { useTranslation } from 'react-i18next'

interface Props {
    rank?: number | string
    score: string
    name?: string
    tier: string
    rankingCriteria?: RankingCriteria
}

export const UserRank: React.FC<Props> = ({
    rank,
    score,
    name,
    tier,
    rankingCriteria,
}) => {
    const { t } = useTranslation()
    const columns = [
        {
            dataIndex: 'rank',
            key: 'rank',
            width: '14%',
            render(text: string) {
                return (
                    <BitazzaText
                        content={text}
                        color="#fff"
                        format="t18"
                        noWrap
                    />
                )
            },
        },
        {
            dataIndex: 'name',
            key: 'name',
            width: '58%',
            render(text: string, record: any) {
                return (
                    <div className={Styles.tableName}>
                        <Badges type={record.type} userRank />
                        <BitazzaText
                            content={text}
                            color="#fff"
                            format="t18"
                            noWrap
                        />
                    </div>
                )
            },
        },
        {
            dataIndex: 'pnl',
            key: 'pnl',

            render(text: number) {
                return (
                    <div className={Styles.pnlWrapper}>
                        <BitazzaText
                            content={`${Number(text)?.toFixed(2)}%`}
                            color={getColor(+text)}
                            format="t18"
                            strong
                            noWrap
                        />
                    </div>
                )
            },
        },
    ]

    const data = [
        {
            key: rank,
            rank: rank,
            name: name,
            pnl: score || 0,
            type: tier,
        },
    ]

    const noteHandler = () => {
        if (rank !== 'N/A') return
        if (rankingCriteria?.join_season) {
            if (rankingCriteria.require_more_trades > 0)
                return (
                    <div className={Styles.moreTrade}>
                        <BitazzaText
                            color="#86A1A1"
                            content={t('txt_more_trade_1')}
                            format="t12"
                        />{' '}
                        <BitazzaText
                            bold
                            color="#EBAA24"
                            content={rankingCriteria.require_more_trades}
                            format="t12"
                        />{' '}
                        {rankingCriteria.require_more_trades === 1 ? (
                            <BitazzaText
                                color="#86A1A1"
                                content={t('txt_more_trade_3')}
                                format="t12"
                            />
                        ) : (
                            <BitazzaText
                                color="#86A1A1"
                                content={t('txt_more_trade_2')}
                                format="t12"
                            />
                        )}
                    </div>
                )
            else return
        } else
            return (
                <>
                    <div className={Styles.moreTrade}>
                        <BitazzaText
                            color="#86A1A1"
                            content={t('txt_your_ranking')}
                            format="t12"
                        />{' '}
                        <BitazzaText
                            color="#86A1A1"
                            content={t('txt_join_later')}
                        />
                    </div>
                </>
            )
    }

    return (
        <div className={Styles.container}>
            <div className={Styles.tableUser}>
                <Table
                    showHeader={false}
                    tableLayout="fixed"
                    className={Styles.table}
                    bordered={false}
                    rowClassName={Styles.rowUserRank}
                    dataSource={data}
                    columns={columns}
                    pagination={false}
                />
            </div>
            {noteHandler()}
        </div>
    )
}
